import {isKeyInStorage, getKeyFromStorage, setKeyInStorage, deleteKeyFromStorage} from "../storage/local_storage_store";

const JWT_TOKEN_KEY = "tipzyy.jwt.v3";

/**
 * Is JWT in storage?
 *
 * @return {boolean}
 */
const isJWTInStorage = () => isKeyInStorage(JWT_TOKEN_KEY);

/**
 * Get raw JWT token from storage
 *
 * @return {String|null}
 */
const getJWT = () => {
  if (!isJWTInStorage()) {
    return null;
  }

  return getKeyFromStorage(JWT_TOKEN_KEY);
};

/**
 * Set JWT (store it)
 *
 * @param jwt {String}
 */
const setJWT = jwt => setKeyInStorage(JWT_TOKEN_KEY, jwt);

/**
 * Delete JWT token from storage
 */
const deleteJWT = () => deleteKeyFromStorage(JWT_TOKEN_KEY);

/**
 * Get header from JWT (Parsed)
 *
 * @param jwt {String|null}
 * @return {Object|null}
 */
const getHeaderFromJWT = jwt => {
  if (!jwt) {
    return null;
  }

  const pieces = jwt.split(".");
  const header = atob(pieces[0]);

  try {
    return JSON.parse(header);
  } catch {
    return null;
  }
};

/**
 * Get payload from JWT (Parsed)
 *
 * @param jwt {String|null}
 * @return {Object|null}
 */
const getPayloadFromJWT = jwt => {
  if (!jwt) {
    return null;
  }

  const pieces = jwt.split(".");
  const header = atob(pieces[1]);

  try {
    return JSON.parse(header);
  } catch {
    return null;
  }
};

/**
 * Get user payload from JWT (Parsed)
 *
 * @param jwt {String|null}
 * @return {Object|null}
 */
const getUserPayloadFromJWT = jwt => {
  const payload = getPayloadFromJWT(jwt);
  if (!payload) {
    return null;
  }

  return "undefined" !== typeof (payload.data) ? payload.data : null;
};

export {getUserPayloadFromJWT, setJWT, getJWT, deleteJWT};
